module.exports = __webpack_public_path__ + "img/violet_111.f67e9b0f.png";